import React, { MouseEvent } from 'react';
import { Dialog as MuiDialog, Box, Slide } from '@material-ui/core';
import { DialogActions, DialogContent, DialogText, DialogTitle } from '../styles';
import { ButtonSubmit } from 'components/shared/Form';
import { TransitionProps } from '@material-ui/core/transitions';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      '& .MuiDialog-paper': {
        margin: '0'
      },
      '& .MuiDialogContent-root:first-child': {
        paddingTop: '0'
      }
    }
  })
);

interface IDialogProps {
  title: string;
  text: string | JSX.Element;
  // buttons?: Array<string>;
  onClose: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void) | undefined;
  onClick: (event: MouseEvent | undefined) => void;
  open: boolean;
  alignItems?: 'center' | 'flex-end' | 'flex-start';
}

export function Dialog({ title, text, onClose, onClick, open, alignItems = 'flex-start' }: IDialogProps) {
  const classes = useStyles();

  return (
    <MuiDialog
      fullWidth
      maxWidth="sm"
      className={classes.dialog}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="dialog-slide-title"
      aria-describedby="dialog-slide-description"
    >
      <Box display="flex" flexDirection="column" alignItems={alignItems} p="24px">
        <DialogTitle id="dialog-slide-title">{title}</DialogTitle>

        <DialogContent>
          <DialogText id="dialog-slide-description">
            {text}
          </DialogText>
        </DialogContent>

        <DialogActions>
          <ButtonSubmit onClick={onClick} color="primary">
            Ok
          </ButtonSubmit>
        </DialogActions>
      </Box>
    </MuiDialog>
  );
}